// import React from 'react'
import "react-toastify/dist/ReactToastify.css";
import "../pages/UtmVisualization/productSearch.css"
import DatePicker from 'react-datepicker'
const DatePickerCom = ({ handleDateChange, currentDate }) => {
  return (
    <DatePicker
      selected={currentDate}
      onChange={(date) => handleDateChange(date)}
      dateFormat="dd-MM-yyyy"
      className="form-input-field"
      wrapperClassName="date-picker-wrapper"
    />
  )
}

export default DatePickerCom